import {useCallback} from 'react';

import {dateRangeToWorksheetName} from '../../../../../../../component/request-report-base/request-report-base-helper';
import {
    defaultReportTypeOptions,
    ExportReportModeEnum,
} from '../../../../../../../component/request-report-base/request-report-popup/request-report-popup-const';
import {useLocale} from '../../../../../../../provider/locale/locale-hook';
import {Locale} from '../../../../../../../provider/locale/localization';
import {fetchReviewsAnalysisTagList} from '../../../../../../../service/reivew-analysis/review-analytics-tags/review-analytics-tags-api';
import {
    ReviewsAnalysisTagsQueryType,
    ReviewsAnalysisTagType,
} from '../../../../../../../service/reivew-analysis/review-analytics-tags/review-analytics-tags-type';
import {ReviewsAndAnswersStatisticsUnitMeasurementEnum} from '../../../../../../../service/reviews-and-answers-statistics/reviews-and-answers-statistics';
import {TimeSizeEnum} from '../../../../../../../util/format';
import {useFormat} from '../../../../../../../util/format-hook/format-hook';
import {RequestReport} from '../../../../components/request-report/request-report';
import {useReviewsAnalysisFilter} from '../../../../reviews-analysis-hook';
import {tagsPageTableColumns} from '../../keywords-and-topics-page-helper';

export function RequestKeywordsReport(): JSX.Element {
    const {getLocalizedString} = useLocale();
    const {singleFilter} = useReviewsAnalysisFilter(false);

    const {getFormattedNumber} = useFormat();

    function formatDataForXls(data: Array<ReviewsAnalysisTagType>) {
        return data.map((tagInfo) => ({
            [getLocalizedString('REVIEWS_ANALYSIS__TABLE__COLUMN__TAG')]: tagInfo.tag,
            [getLocalizedString('REVIEWS_ANALYSIS__TABLE__COLUMN__RATE')]: tagInfo.avgRating.toFixed(1),
            [getLocalizedString('REVIEWS_ANALYSIS__TABLE__COLUMN__REVIEW_TOTAL')]: tagInfo.total,
            [getLocalizedString('REVIEWS_ANALYSIS__TABLE__COLUMN__REVIEWS_REPLIED')]: tagInfo.replied,
            [getLocalizedString('REVIEWS_ANALYSIS__TABLE__COLUMN__REPLY_DELAY__WITH_UNIT')]: tagInfo.avgResponseSpeed
                ? getFormattedNumber(tagInfo.avgResponseSpeed, {style: 'unit', unit: TimeSizeEnum.minute})
                : '-',
            [`${getLocalizedString('REVIEWS_ANALYSIS__TABLE__COLUMN__SENTIMENT')}: ${getLocalizedString(
                'REVIEWS_ANALYSIS__SENTIMENT__POSITIVE'
            )}`]: tagInfo.sentiment.positive,
            [`${getLocalizedString('REVIEWS_ANALYSIS__TABLE__COLUMN__SENTIMENT')}: ${getLocalizedString(
                'REVIEWS_ANALYSIS__SENTIMENT__NEUTRAL'
            )}`]: tagInfo.sentiment.neutral,
            [`${getLocalizedString('REVIEWS_ANALYSIS__TABLE__COLUMN__SENTIMENT')}: ${getLocalizedString(
                'REVIEWS_ANALYSIS__SENTIMENT__NEGATIVE'
            )}`]: tagInfo.sentiment.negative,
            [`${getLocalizedString('REVIEWS_ANALYSIS__TABLE__COLUMN__SENTIMENT')}: ${getLocalizedString(
                'REVIEWS_ANALYSIS__SENTIMENT__UNSPECIFIED'
            )}`]: tagInfo.sentiment.unspecified,
        }));
    }

    const getDataSource = useCallback((array: Array<ReviewsAnalysisTagType>) => {
        return array;
    }, []);

    return (
        <RequestReport<ReviewsAnalysisTagType, ReviewsAnalysisTagType, ReviewsAnalysisTagsQueryType>
            apiHandler={fetchReviewsAnalysisTagList}
            columns={tagsPageTableColumns({
                timeUnit: singleFilter.timeFormat || ReviewsAndAnswersStatisticsUnitMeasurementEnum.Minutes,
            })}
            defaultFilename={getLocalizedString('REVIEWS_ANALYSIS__KEYWORDS_AND_TOPICS__KEYWORDS_TITLE')}
            filters={{...singleFilter}}
            formatDataForXls={formatDataForXls}
            getDataSource={getDataSource}
            reportTypeOptions={defaultReportTypeOptions.filter((option) => option.mode === ExportReportModeEnum.excel)}
            title={<Locale stringKey="REVIEWS_ANALYSIS__KEYWORDS_AND_TOPICS__KEYWORDS_TITLE" />}
            xlsxWorksheetName={dateRangeToWorksheetName({
                rawStartDate: singleFilter.startDate,
                rawEndDate: singleFilter.endDate,
            })}
        />
    );
}
